// extracted by mini-css-extract-plugin
export default {"headingOfProject":"Project_headingOfProject__Mw1Xm","ProjectContainer":"Project_ProjectContainer__DYG7S"};